export const TopPicksPrioritySectionEntityIds = [
  "505323", // CORONAVIRUS
  "507450", // US_CHINA_RELATIONS
  "507589", // CHINA_MACRO_ECONOMY
  "509909", // OLYMPICS
];
